// Partidas comentadas (2026-10-18): partidas reales de juegoxima.com explicadas jugada a jugada.
// Las valoraciones salen del análisis del bot (Analizar partida); la notación es la del libro, en modo largo.

export const PARTIDAS_COMENTADAS_GUIDES = [
  {
    slug: "articulos/partida-comentada-power-adrianwrj",
    theme: "estrategia",
    nav: "power contra adrianwrj",
    title: "Partida comentada de XIMA: power contra adrianwrj (Modo Ciencia)",
    description:
      "Una partida real de juegoxima.com explicada jugada a jugada: capturas, un especial atrapado dos veces, el escalón que decidió la partida y el final en la cima.",
    h1: "Partida comentada: power contra adrianwrj",
    intro:
      "La mejor forma de aprender XIMA es ver jugar a los buenos. Esta es una partida real entre dos de los jugadores más fuertes de juegoxima.com, sin dados y a un ritmo rápido. Los dos jugaron con más del 90 % de precisión según el bot, y aun así la partida se decidió por un solo bloque mal colocado.",
    sections: [
      {
        h: "La partida en datos",
        defs: [
          ["Modo", "Ciencia (sin dados), 2 jugadores."],
          ["Fecha", "26 de septiembre de 2026, en juegoxima.com."],
          ["Azul (sale primero)", "power, con un 91 % de precisión."],
          ["Rojo", "adrianwrj, con un 94 % de precisión."],
          ["Duración", "40 jugadas (80 movimientos) en unos 16 minutos."],
          ["Resultado", "0-1: gana adrianwrj llevando su especial a la cima."],
        ],
        after: [
          "La precisión y las valoraciones (?, ?!, !?) salen de Analizar partida, el bot que revisa cada movimiento. Las jugadas se escriben en modo largo: «A12D9» es mover de A12 a D9, «-L1» es incorporar un bloque común en L1, «=F7» es incorporar el especial y la «x» marca una captura. «6... A12D9» quiere decir que es el movimiento de las rojas en la jugada 6.",
          "En los diagramas el tablero se ve desde arriba: azul oscuro es el primer piso, verde azulado el segundo, morado el tercero y la casilla dorada, G7, la cima. El número sobre un bloque dice cuántos hay en esa columna y los cuadritos de abajo son los bloques que quedan debajo; la estrella marca el especial. El recuadro verde señala el último movimiento.",
        ],
      },
      {
        h: "La apertura: los dos llenan los bordes (jugadas 1 a 6)",
        p: [
          "power empieza por abajo con -L1, -K1 y -D1, y luego mete bloques por arriba (-D13) y por la izquierda (-A2). adrianwrj se queda en la esquina de arriba a la izquierda: -A2, -A12, -A11 y, en la jugada 4, apila un segundo bloque en A12 con A2A12. Las primeras jugadas de los dos el bot las da como «de libro»: son las entradas habituales.",
          "Esa pila no es casualidad. Un bloque encima de otro ya está una altura más arriba, y eso es justo lo que hace falta para empezar a subir. Con 5... A11B11 adrianwrj pone además un bloque en B11, y en la jugada 6 lo usa: 6... A12D9 saca el bloque de arriba de la pila de A12, pasa por encima de B11 como si fuera un escalón y llega a D9, ya en el segundo piso.",
          "Es la idea más importante de XIMA: cada piso está dos alturas por encima del anterior y un bloque solo sube una altura por paso, así que para subir de piso necesitas otro bloque que haga de escalón.",
        ],
        figure: "partida-power-adrianwrj-12",
      },
      {
        h: "La primera captura (jugadas 7 y 8)",
        p: [
          "power responde 7. D13B11 y se sube encima del bloque rojo de B11: lo domina. Pero adrianwrj tiene la respuesta preparada. 7... D9xB11 vuelve desde D9 a la misma columna: ahora hay dos rojos y un azul, y el azul queda capturado.",
          "La regla es esta: el que termina el movimiento captura los bloques de los colores que tienen menos que él en esa columna. Dos contra uno captura; uno contra uno solo domina. Por eso, cuando power vuelve a subirse a B11 con 8. C11B11, domina la columna pero ya no puede capturar: es uno contra dos.",
        ],
        figure: "partida-power-adrianwrj-14",
      },
      {
        h: "La lucha en las esquinas (jugadas 9 a 17)",
        p: [
          "Durante unas cuantas jugadas la partida se mueve por los bordes. power acumula bloques en L1 y K1 y los dos se disputan la esquina de abajo a la izquierda. Allí adrianwrj logra la segunda captura de la partida con 16... C3xA3: otra vez dos rojos contra un azul en la misma columna.",
          "La lección se repite: cuando tienes dos bloques en una columna, el rival no puede capturarla con uno solo. Las columnas dobles son las casas seguras de XIMA.",
        ],
      },
      {
        h: "El especial de power entra… y queda atrapado (jugadas 17 a 20)",
        p: [
          "17... B3B10!? es una jugada curiosa de adrianwrj: lleva un bloque desde B3 hasta B10, junto al borde izquierdo. power aprovecha ese bloque rojo como escalón y mete su especial con 18. =C10: entra por A10, pasa por encima de B10 y se queda en C10, en el segundo piso. El bot prefería entrar una casilla más adentro, en D10.",
          "adrianwrj no le da tiempo a moverlo. Con 18... -D8, 19... D8C9 y 20... C9C10 lleva un bloque común justo encima del especial azul. Como es uno contra uno no hay captura, pero solo se mueve el bloque de arriba de cada columna: un especial dominado está congelado. Muchas veces conviene dominar el especial contrario en vez de capturarlo, porque capturado se puede rescatar y volver a entrar en un sitio mejor.",
        ],
        figure: "partida-power-adrianwrj-40",
      },
      {
        h: "El error que decidió la partida (jugadas 21 a 26)",
        p: [
          "adrianwrj prepara la entrada de su propio especial. Con 21... B10B7 deja un bloque en B7, en el primer piso, y 22... -C6?! es la única imprecisión que el bot le señala: era mejor ocupar D7 con -D7.",
          "En la jugada 26 power comete el único error de la partida: 26. D10D7?, que pone un bloque azul justo en D7. Según el bot, esa jugada le quita un 18 % de probabilidad de ganar; lo mejor era D10C11. ¿Por qué es tan grave? Porque ahora la fila 7 tiene escalones en B7 y en D7, y adrianwrj lo ve en el acto.",
          "26... =F7 mete el especial rojo por A7. En un solo movimiento sube por encima del bloque rojo de B7, llega a C7 en el segundo piso, pasa por encima del bloque azul de D7 y sube a E7 y F7, en el tercer piso, al lado de la cima. El bloque que power acababa de poner le sirvió de escalón al especial rival.",
          "Es la lección más útil de esta partida: antes de colocar un bloque, mira si el rival lo puede usar para subir. En XIMA tus bloques también son escalones para el otro.",
        ],
        figure: "partida-power-adrianwrj-52",
      },
      {
        h: "power libera a su especial (jugadas 27 a 32)",
        p: [
          "El especial rojo se aparta a F6 con 27... F7F6 y empieza una pelea en el centro. adrianwrj captura otro bloque azul con 31... F5xE4, pero power encuentra la mejor jugada: 32. E8xC10.",
          "El bloque azul de E8 baja por encima de D9 y cae en la columna de C10, donde estaba el especial azul con el bloque rojo encima. Ahora hay dos azules contra un rojo: el rojo queda capturado y el especial de power vuelve a estar libre.",
        ],
        figure: "partida-power-adrianwrj-63",
      },
      {
        h: "Otra vez atrapado (jugadas 33 y 34)",
        p: [
          "power quita su bloque de encima con 33. C10C11 y saca el especial a D9 con 34. C10D9. Pero adrianwrj contesta en el acto con 34... E8D9 y lo vuelve a tapar con un bloque rojo.",
          "Liberar el especial no basta: hay que sacarlo a una casilla a la que el rival no llegue en la jugada siguiente.",
        ],
      },
      {
        h: "El final: un escalón al lado de la cima (jugadas 35 a 39)",
        p: [
          "Con el especial azul otra vez dominado, adrianwrj ya solo necesita una cosa: un escalón junto a la cima. El especial rojo está en F6, en el tercer piso, pero la cima está dos alturas más arriba y, como siempre, solo se puede subir una por paso.",
          "38... D3G6 lleva un bloque común rojo desde D3, por encima del bloque rojo de E4, hasta G6, justo al lado de la cima. Y 39... F6G6 sube el especial encima de ese bloque.",
        ],
        figure: "partida-power-adrianwrj-78",
      },
      {
        h: "Cima: gana adrianwrj",
        p: [
          "Desde G6 el especial ya está a una sola altura de la cima. power juega 40. D3F5, que según el bot era su mejor jugada, pero ya no hay forma de impedirlo: 40... G6G7 y adrianwrj gana.",
          "adrianwrj no ganó por quitarle más bloques a power, sino por tener el especial cerca de la cima y construir a tiempo el último escalón.",
        ],
        figure: "partida-power-adrianwrj-80",
      },
      {
        h: "Qué aprendemos de esta partida",
        list: [
          "Para subir hacen falta escalones. Una pila de dos bloques en el borde (A12) es la forma más rápida de empezar a subir.",
          "Dos contra uno captura. Las columnas con dos bloques tuyos son difíciles de atacar.",
          "Tus bloques también son escalones para el rival. El error de la jugada 26 fue dejarle a adrianwrj el bloque de D7 en el camino de su especial.",
          "Un especial dominado no se mueve. Mételo cuando el rival no pueda subirse encima, o tenlo cubierto.",
          "En el final, el especial necesita un escalón al lado de la cima. Prepáralo antes de que el rival lo vea venir.",
        ],
      },
      {
        h: "Todas las jugadas",
        table: {
          head: ["N.º", "power (azul)", "adrianwrj (rojo)"],
          rows: [
            ["1.", "-L1", "-A2"],
            ["2.", "-K1", "-A12"],
            ["3.", "-D1", "-A11"],
            ["4.", "-D13", "A2A12"],
            ["5.", "-A2", "A11B11"],
            ["6.", "-C11", "A12D9"],
            ["7.", "D13B11", "D9xB11"],
            ["8.", "C11B11", "A12A2"],
            ["9.", "D1L1", "-B1"],
            ["10.", "-K2", "B1L1"],
            ["11.", "K1K3", "-K1"],
            ["12.", "K2K1", "-A3"],
            ["13.", "-K2", "-B3"],
            ["14.", "K3C3", "A2C4"],
            ["15.", "A2A3", "C4C3"],
            ["16.", "-C4", "C3xA3"],
            ["17.", "C3A3", "B3B10!?"],
            ["18.", "=C10", "-D8"],
            ["19.", "C4C9", "D8C9"],
            ["20.", "B11C11!?", "C9C10"],
            ["21.", "K1K3", "B10B7"],
            ["22.", "K3C3", "-C6?!"],
            ["23.", "C3C6", "K1K3"],
            ["24.", "C9D10", "K3D3!?"],
            ["25.", "C11E9", "B11C11"],
            ["26.", "D10D7?", "=F7"],
            ["27.", "C6D7", "F7F6"],
            ["28.", "D7E8", "C6E4"],
            ["29.", "E8E4", "D3D7"],
            ["30.", "E9E8", "D7F5"],
            ["31.", "D7D9", "F5xE4"],
            ["32.", "E8xC10", "E4E8"],
            ["33.", "C10C11", "B11B7"],
            ["34.", "C10D9", "E8D9"],
            ["35.", "C11C6", "C11C6"],
            ["36.", "K2B2", "B7D7"],
            ["37.", "B2B7", "D7D3"],
            ["38.", "B7D7", "D3G6"],
            ["39.", "D7D3", "F6G6"],
            ["40.", "D3F5", "G6G7 (cima) 0-1"],
          ],
        },
        after: [
          "?: error · ?!: imprecisión · !?: jugada interesante, según el bot. Las demás jugadas el bot las valora como buenas, excelentes o las mejores posibles.",
        ],
      },
    ],
    faqs: [
      ["¿Quién ganó la partida?", "adrianwrj, con las rojas, al llevar su especial a la cima (G7) en la jugada 40."],
      ["¿Cuál fue la jugada clave?", "26. D10D7?: power puso un bloque en D7 que le sirvió de escalón al especial rojo para entrar hasta F7, en el tercer piso."],
      ["¿Cómo puedo analizar mis propias partidas así?", "En juegoxima.com, abre la partida desde Historial y pulsa Analizar partida: el bot valora cada jugada y te enseña la mejor."],
    ],
    related: ["reglas/subir-bloques", "reglas/dominacion-y-captura", "sistema-de-anotacion", "analizar-partida", "estrategia/finales-xima"],
    cta: { label: "Juega una partida", slug: "partidas-online" },
  },
];
